<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Branch Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <form data-vv-scope="queryBranchFilterForm">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-sm>
                        <v-layout row wrap>
                          <v-flex lg6 xs12>
                            <v-text-field
                              data-vv-scope="queryBranchFilterForm"
                              v-model="filtersBranch.branch"
                              :label="filtersBranchLabel.branch"
                              :error-messages="errors.collect('filterBranch')"
                              data-vv-name="filterBranch"
                              :data-vv-as="filtersBranchLabel.branch"
                              v-validate="'entry|max:20'"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions right>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearBranchFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text @click.prevent="doBranchFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
        <v-flex xs12 class="mt-2">
          <v-card>
            <v-card-text>
              <v-data-table
                v-bind:headers="headers"
                v-bind:items="items"
                :footer-props="{ 'items-per-page-options': itemsPerPage }"
                :server-items-length="totalItemsBranch"
                v-bind:options.sync="pagination"
                item-key="key"
                :loading="loading"
                :no-data-text="noDataText"
                :custom-filter="customSearch"
                v-model="selected"
                show-select
                @input="enterSelect"
                @toggle-select-all="enterSelectAll(pagination, items, selected)(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected.</div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class="mr-2" @click="doSelect('All', 'branch')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class="mr-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn
              >
              <v-btn color="primary" dark class="mr-2" @click="doSelect('', 'branch')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { creditNoteFilterMixin } from '@/mixins/accounting/creditNote/creditNoteFilterMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'

export default {
  data() {
    return {
      headers: [
        { text: 'Branch', value: 'branch' },
        { text: 'Description', value: 'brnDesc' }
      ],
      pagination: {
        sortDesc: [false],
        page: 1
      },
      items: [],
      branchItems: [],
      branches: []
    }
  },
  mounted() {
    // this.doClearBranchFilters()
    this.doGetBranchList()
  },
  methods: {
    closeDialog() {
      this.filtersBranch.branch = ''
      this.$emit('close')
    },
    doClearBranchFilters() {
      this.filtersBranch.branch = ''
      this.doGetBranchList()
    },
    doBranchFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryBranchFilterForm').then((result) => {
        if (result) {
          this.paginationBranch.page = 1
          this.doGetBranchList()
        }
      })
    },
    async doGetBranchList() {
      if (this.brn !== null && this.brn !== '' && this.brn !== undefined) {
        this.branches = this.brn.split(',')
      }
      const apiURI = this.$store.state.commons.menu.branchesList
      if (apiURI) {
        this.loading = true
        const { page, itemsPerPage } = this.paginationBranch
        const expand = {
          page: page - 1,
          size: itemsPerPage
        }
        let massageFilters = clone(this.filtersBranch)
        const result = await this.$http.get(
          filterQuery(expandURI(apiURI, expand), massageFilters, this.paginationBranch.sortBy, this.paginationBranch.sortDesc)
        )
        if (result.data) {
          this.items = []
          this.totalItemsBranch = result.data.totalElements
          const { data } = result.data
          if (data) {
            data.map((brnList) => {
              const convertList = {
                key: brnList.branch,
                branch: brnList.branch,
                brnDesc: brnList.branchDesc
              }
              if (this.checkedItems.includes(brnList.branch)) {
                const branchList = {
                  key: brnList.branch,
                  branch: brnList.branch,
                  brnDesc: brnList.branchDesc
                }
                this.selectedItems.push(branchList)
              }
              this.items.push(convertList)
            })
          }
          if (this.checkedItems.toString() === 'All') {
            this.doReset()
            this.toggleAll()
          } else {
            this.toggleSelected()
          }
          this.loading = false
        }
      }
    }
  },
  computed: {
    usrId() {
      return this.$store.state.token.usrId
    }
  },
  mixins: [TableConst.default, MessageMixin, helpListMixin, commonAjaxMixin, creditNoteFilterMixin],
  props: {
    menu: Object,
    brn: String
  }
}
</script>

<style>
</style>
